import React from "react";

export function EmptyState({ icon: Icon, title, description, action, testId }) {
  return (
    <div
      data-testid={testId || "empty-state"}
      className="flex flex-col items-center justify-center text-center py-20 px-6 rounded-2xl border border-dashed border-border bg-white/50"
    >
      {Icon && (
        <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-terracotta-light text-terracotta">
          <Icon className="h-6 w-6" />
        </div>
      )}
      <h3 className="font-display text-xl font-semibold tracking-tight text-slateink">{title}</h3>
      {description && <p className="mt-2 max-w-md text-sm text-muted-foreground leading-relaxed">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
